import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IdexService } from 'app/idex.service';
import { DocListComponent } from '../doclist/doclist.component';
import { Path } from 'app/shared/path';
import {DownloadZipComponent} from '../download-zip/download-zip.component';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {MoveDialogComponent} from '../move/move.component';
import { TranslateService } from '@ngx-translate/core';
import { Toast } from 'app/shared/toast/toast';
import { ConfirmDeleteComponent } from '../confirm-delete/confirm-delete.component';
import {FileUploader} from '../file-uploader';
import {UploadProgressComponent} from '../upload-progress/upload-progress.component';
import {FileSizePipe} from '../../shared/file-size.pipe';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.css'],
})
export class SearchComponent implements OnInit {
   @ViewChild(DocListComponent, { static: true }) docList: DocListComponent;
   @ViewChild('fileUpload') fileUpload: any;
   @ViewChild('progress') progress: UploadProgressComponent;
   private q: string;
   private pos = 0;
   private size = 50;
   result: any;
   selectedItems: any[] = [];
   permisionMove = true;
   permisionDel = true;
   private movedialog: MatDialogRef<MoveDialogComponent>;
   limitSize = 10485760;
   limit: any;

   private uploadCallback = {
      init: (files) => {
         this.progress.init(files);
      },
      quotaExceed: (i: number, size: number, error: string) => {
         this.progress.quotaExceed(i, size, error);
      },
      limitExceed: (i: number, size: number) => {
         this.progress.limitExceed(i, size, this.limit);
      },
      progress: (i: number, progress: number) => {
         this.progress.update(i, progress);
      },
      cancelUpload: (i: number, error: string) => {
         this.progress.cancelUpload(i, error);
      },
      complete: () => {
         this.progress.complete();
         setTimeout(() => {
            this.progress.hide();
            this.pos = 0;
            this.search();
         }, this.progress.calcDelay());
      }
   };

   constructor(private route: ActivatedRoute, private router: Router,
               private service: IdexService, public dialog: MatDialog,
               private uploader: FileUploader, private fileSize: FileSizePipe,
               private translate: TranslateService, private toast: Toast) {}

   ngOnInit() {
      this.route.queryParams.subscribe(params => {
         this.q = decodeURIComponent(params['q']);
         if (this.q === undefined) {
            return;
         }
         this.pos = 0;
         this.docList.items = undefined;
         this.result = undefined;
         this.search();
         this.getLimitSize();
         this.limit = this.fileSize.transform(this.limitSize);
      });
   }

   setPos(pos) {
      this.pos = pos;
   }

   search() {
      this.service.search(encodeURIComponent(this.q) , this.pos, this.size, true, true).subscribe(
         data => {
            this.result = { found: data.total, searchedFor: data.searchedFor };
            if (data.hasMore && (this.pos + this.size) > data.total) {
               data.hasMore = false;
            }
            if (this.pos === 0) {
               this.docList.setItems(data.items, data.hasMore);
            } else {
               this.docList.addItems(data.items, data.hasMore);
            }
            this.pos += this.size;
         });
   }

   onClickItem(item: any) {
      let path = location.pathname + '?q=' + this.q;
      const idex = '/idex';
      if (path.startsWith(idex)) {
         path = path.substring(idex.length);
      }
      localStorage.setItem('url', encodeURIComponent(path));

      if (item.isFolder) {
         let url = Path.combine('/files', item.path, item.fileName);
         if (!item.path.startsWith('/')) {
            url = Path.combine('/work', item.linkPath, item.fileName);
         }
         this.router.navigate([url]);
      } else {
         this.router.navigate(['/file', item.id]);
      }
   }

   onItemAllSelect(chk: any) {
      for (let i = 0; i < this.docList.items.length; i++) {
         this.docList.items[i].selected = chk.checked;
         const index = this.selectedItems.indexOf(this.docList.items[i]);
         if (this.docList.items[i].selected) {
            if (index === -1) {
               this.selectedItems.push(this.docList.items[i]);
            }
         } else {
            if (index !== -1) {
               this.selectedItems.splice(index, 1);
            }
         }
      }
   }

   checkSelectItem() {
      this.permisionMove = true;
      this.permisionDel = true;
      if (this.selectedItems) {
         for (const itemSel of this.selectedItems) {
            if (!(itemSel.permissions.write && itemSel.permissions.delete)) {
               this.permisionMove = false;
            }

            if (!itemSel.permissions.delete) {
               this.permisionDel = false;
            }

            if (itemSel.startFlow) {
               this.permisionDel = false;
               break;
            }

            if (!this.permisionMove && !this.permisionDel) {
               break;
            }
         }
      }
   }

   selectedDownload() {
      const listIds = [];
      let name = 'Archive';
      if (this.selectedItems) {
         if (this.selectedItems.length === 1) {
            name = this.selectedItems[0].name;
         }
         for (const itemSel of this.selectedItems) {
            listIds.push(itemSel.id);
         }
      }

      this.dialog.open(DownloadZipComponent, {
         disableClose: true,
         data: {
            idList: listIds,
            name: name,
            service: this.service
         }
      });
   }

   openSelectedMove() {
      this.movedialog = this.dialog.open(MoveDialogComponent, {
         disableClose: true,
         data: { service: this.service, listItem: this.selectedItems,
            isMultiSelect: true, data: this, toast: this.toast, translate: this.translate }
      });
      this.movedialog.afterClosed().subscribe(result => {
         if (result) {
            this.selectedItems = [];
            this.pos = 0;
            this.search();
         }
      });
   }

   confirmDelete(): void {
      const dialogRef = this.dialog.open(ConfirmDeleteComponent, {
         disableClose: true,
         data: { service: this.service, listItem: this.selectedItems,
            isMultiSelect: true, data: this, toast: this.toast, translate: this.translate }
      });
      dialogRef.afterClosed().subscribe(result => {
         if (result) {
            this.selectedItems = [];
            this.pos = 0;
            this.search();
         }
      });
   }

   uploadNewVersion(event: any): void {
      if (event.item.linkPath) {
         const linkPath = event.item.linkPath;
         const tin = linkPath.substring(0, 13);
         const path = linkPath.substring(13);
         this.uploader.uploadFolder(event.file, this.limitSize, path, tin, this.uploadCallback, event.item.id);
         return ;
      }
      this.uploader.uploadFolder(event.file, this.limitSize, event.item.path, null, this.uploadCallback, event.item.id);
   }

   getLimitSize() {
      this.service.get('upload/limitsize')
         .subscribe(value => {
            this.limitSize = value;
            this.limit = this.fileSize.transform(this.limitSize);
         });
   }
}
